import { Stack } from '@mui/material'
import { FeatureFlagIdAccountProvisioning } from 'c1gen/features'
import { TaskV1TaskServiceCreateRevokeTask } from 'c1gen/permissions'
import { AppV1AppUserServiceowner } from 'c1gen/roles'
import { useFeatureChecker, useHasPermission, useHasRole } from 'components/no-ui/capability'
import { AppUserValue } from 'lib/actions/apps/app-users'
import { FC } from 'react'
import { AppUserActionOptions, AppUserActionsDropdown } from './AppUserActionsDropdown'
import { AppUserCredentialsAction } from './AppUserCredentialsAction'
import { AppUserManageGrantsButton } from './AppUserManageGrants'

export type AppUserActionsColumnProps = {
    userId?: string
    appUser: AppUserValue
    moreButtonOptions: AppUserActionOptions[]
    showManageGrantsButton?: boolean
    revokeVisibleOnly?: boolean
    showCredentialsAction?: boolean
}

export const AppUserActionsColumn: FC<AppUserActionsColumnProps> = ({
    appUser,
    moreButtonOptions = [],
    showManageGrantsButton = false,
    userId,
    revokeVisibleOnly = false,
    showCredentialsAction = false,
}) => {
    const hasRoleServiceOwner = useHasRole(AppV1AppUserServiceowner)
    const hasPermissionCreateRevokeTask = useHasPermission(TaskV1TaskServiceCreateRevokeTask)
    const hasAccountProvisioningFeature = useFeatureChecker(FeatureFlagIdAccountProvisioning) || false

    const btnProps = revokeVisibleOnly && userId
        ? ({ appUser, revokeVisibleOnly: true, userId } as const)
        : ({ appUser, revokeVisibleOnly: false } as const)
    return <Stack direction="row" spacing={1}>
        {
            showCredentialsAction && hasAccountProvisioningFeature && <AppUserCredentialsAction appUser={appUser} />
        }
        {
            showManageGrantsButton && hasPermissionCreateRevokeTask && <AppUserManageGrantsButton {...btnProps} />
        }
        {
            moreButtonOptions.length > 0 && hasRoleServiceOwner && (
                <AppUserActionsDropdown appUser={appUser} options={moreButtonOptions} />
            )
        }
    </Stack>
}
